import { apiClient } from "../common/axiosInstance";
import { handleAxiosError } from "../common/handleAxiosError";

export const getAllCompanies = async () => {

  try {
    const response = await apiClient.get("/company");
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener las compañías");
  }
};
